<div class="common-keywords-container">
    <div class="display-content mt-4 mb-3 text-3xl" [innerHTML]="displayContent"></div>
    <div class="mb-4">
        <div class="mb-3" *ngFor="let display of displayList" >
            <span [innerHTML]="display.list"
                (click)="showAllSearch(display)">
            </span>
        </div>
    </div>
</div>